var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('video',{attrs:{"muted":"","autoplay":"","playsinline":""},domProps:{"muted":true},on:{"ended":_vm.routeHome}},[_c('source',{attrs:{"src":require("../assets/video/crash_video_02.mp4"),"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }